import React from 'react';
import { useTranslation } from 'react-i18next';
import { tArray } from 'cityads-v3/i18n/utils';

import Article, { ArticleImage, ArticleSectionHeader } from 'cityads-v3/components/Article';

export default function BigData(props) {
  const { t } = useTranslation(['BigData']);

  return (
    <Article
      title           = {t('title')}
      pageTitle       = {t('pageTitle')}
      pageDescription = {t('pageDescription')}
      pageKeywords    = {t('pageKeywords')}
      {...props}
    >
      {tArray(t, 'p1', 'p')}

      <ArticleSectionHeader>
        {t('sectionHeader')}
      </ArticleSectionHeader>

      {tArray(t, 'p2', 'p')}

      <ArticleImage
        src={require('./img1.png')}
        caption={t('imageCaption')}
      />

      <ArticleSectionHeader>
        {t('sectionHeader2')}
      </ArticleSectionHeader>

      {tArray(t, 'p3', 'p')}

      <ul>
        {tArray(t, 'list1', 'li')}
      </ul>

      {tArray(t, 'p4', 'p')}

      <ArticleSectionHeader>
        {t('sectionHeader3')}
      </ArticleSectionHeader>

      {tArray(t, 'p5', 'p')}

      <ul>
        {tArray(t, 'list2', 'li')}
      </ul>

      <p>
        {t('p6')}
      </p>
    </Article>
  );
}
